import resources from 'config/resources';
import config from 'config/config';
import { CALL_API } from 'middlewares/apiMiddleware/apiMiddleware';
import {
  getParticipantFirstName,
  getParticipantLastName,
  getSelectedCharity,
  getParticipantPageUrl,
} from 'selectors/apiSelectors/apiSelectors';
import Tools, { getUserGUID } from 'utils/tools/tools';
import { makeActionCreator } from 'utils/reduxUtils/reduxUtils';

export const types = {
  CHARITY_SEARCH_REQUEST: 'CHARITY_SEARCH_REQUEST',
  CHARITY_SEARCH_SUCCESS: 'CHARITY_SEARCH_SUCCESS',
  CHARITY_SEARCH_FAILURE: 'CHARITY_SEARCH_FAILURE',
  GET_PARTICIPANT_REQUEST: 'GET_PARTICIPANT_REQUEST',
  GET_PARTICIPANT_SUCCESS: 'GET_PARTICIPANT_SUCCESS',
  GET_PARTICIPANT_FAILURE: 'GET_PARTICIPANT_FAILURE',
  ADD_CHARITY_ENTITY: 'ADD_CHARITY_ENTITY',
  CREATE_FUNDRAISING_PAGE_REQUEST: 'CREATE_FUNDRAISING_PAGE_REQUEST',
  CREATE_FUNDRAISING_PAGE_SUCCESS: 'CREATE_FUNDRAISING_PAGE_SUCCESS',
  CREATE_FUNDRAISING_PAGE_FAILURE: 'CREATE_FUNDRAISING_PAGE_FAILURE',
  CREATE_DONATION_PAGE_REQUEST: 'CREATE_DONATION_REQUEST',
  CREATE_DONATION_PAGE_SUCCESS: 'CREATE_DONATION_SUCCESS',
  CREATE_DONATION_PAGE_FAILURE: 'CREATE_DONATION_FAILURE',
};

const actions = {
  addCharityEntity: makeActionCreator(types.ADD_CHARITY_ENTITY, 'charityId', 'entity'),

  getParticipant: (guid) => {
    const { url, requestName } = resources.participant;
    return {
      [CALL_API]: {
        requestName,
        types: [types.GET_PARTICIPANT_REQUEST, types.GET_PARTICIPANT_SUCCESS, types.GET_PARTICIPANT_FAILURE],
        endpoint: `${url}/${guid}`,
      },
    };
  },

  getCharitySuggestions: () => (dispatch, getState) => {
    const { url, requestName } = resources.charitySearch;
    const queryText = getState().mainStore.get('queryText');
    if (queryText) {
      dispatch({
        [CALL_API]: {
          requestName,
          types: [types.CHARITY_SEARCH_REQUEST, types.CHARITY_SEARCH_SUCCESS, types.CHARITY_SEARCH_FAILURE],
          endpoint: `${url}/${queryText}`,
        },
      });
    }
  },

  createFundraisingPage: () => (dispatch, getState) => {
    const { requestName } = resources.fundraisingPage;
    const guid = getState().api.getIn(['normalized', 'result', 'participant', 'participantGuid']);
    const charityId = getState().mainStore.get('charityId');
    const jwtAuthToken = getState().mainStore.get('authAccessToken');

    return dispatch({
      [CALL_API]: {
        requestName,
        requestOptions: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtAuthToken}`,
          },
        },
        types: [
          types.CREATE_FUNDRAISING_PAGE_REQUEST,
          types.CREATE_FUNDRAISING_PAGE_SUCCESS,
          types.CREATE_FUNDRAISING_PAGE_FAILURE,
        ],
        endpoint: `${config.PARTNERS_API.BASE_URL}/participant/${guid}/charity/${charityId}`,
      },
    });
  },

  createDonation: () => (dispatch, getState) => {
    const { requestName } = resources.donationPage;
    const state = getState();
    const { api } = state;
    const authAccessToken = state.mainStore.get('authAccessToken');
    const guid = api.getIn(['normalized', 'result', 'participant', 'participantGuid']);
    const causeId = api.getIn(['normalized', 'result', 'participant', 'causeId']);
    const matchMyMilesConfig = api.getIn(['normalized', 'result', 'participant', 'mmmConfig']);
    const {
      charityName,
      charityId: selectedCharityId,
    } = getSelectedCharity(state);
    const mmmUrl = `${window.location.protocol}//${window.location.hostname}`;
    const fundraiserName = `${getParticipantFirstName(state)} ${getParticipantLastName(state)}`;


    const socialShareUrl = getParticipantPageUrl(state) || '';
    const utmContent = `page_${socialShareUrl.substr(socialShareUrl.lastIndexOf('/') + 1)}`;

    const utmMedium = 'share';
    const utmCampaign = 'matchmymiles';
    const utmTerm = Tools.generateHash();

    const twitterUrl = `${socialShareUrl}?utm_source=twitter&utm_medium=${utmMedium}&utm_content=${utmContent}&utm_campaign=${utmCampaign}&utm_term=${utmTerm}`;

    const utmId = guid || '';
    const whatsAppUrl = `${socialShareUrl}?utm_id=${utmId}&utm_content=${utmContent}&utm_term=${utmTerm}`;

    const utmSourceFB = 'facebook';
    const facebookUrl = `${socialShareUrl}?utm_source=${utmSourceFB}&utm_medium=${utmMedium}&utm_content=${utmContent}&utm_campaign=${utmCampaign}&utm_term=${utmTerm}`;


    const postBody = {
      causeId,
      referralCode: 'Cruk-RFL-2015',
      successUri: `${mmmUrl}/summary?guid=${guid}&charityId=${selectedCharityId}`,
      failureUri: `${mmmUrl}/todo--------we-need-a-failure-page`,
      exitUri: `${mmmUrl}/summary?guid=${guid}&charityId=${selectedCharityId}`,
      marketCode: 'GB',
      additionalData: JSON.stringify({
        // version: 1,
        // sourceURI: 'http://www.justgiving.com/my-funky-page',
        sourceURI: facebookUrl,
        cause: {
          name: charityName,
          // image: '533cf657-4642-47a2-ae3a-3e520b0fcc3b.jpg',
          // legacyId: 'E90112F2-8E1A-4EFE-A605-6B77E76F6F0A',
        },
        fundraiser: {
          name: fundraiserName,
          //   avatar: 'fb98c5d3-dbfa-4b03-8bef-71297bb76eb9.jpg',
          userId: getUserGUID(authAccessToken),
        },
        // campaign: {
        //   name: 'Step ot for children',
        // },
        // donor: {
        //   name: 'Don Orange',
        //   avatar: '3d43a92c-8608-4e45-af34-b66e8924d778.jpg',
        // },
        callsToAction: {
          // I’m fundraising for ${charityName} on JustGiving. Will you MatchMyMiles by donating to my cause?
          twitter: `Just donated to my own fundraising page on @JustGiving. Please #MATCHmyMILES by donating and help me hit my target. ${twitterUrl}`,
          // TODO: empty as the FB graph should take the message from the page metadata ( after it has parsed the page )
          facebook: '',
          whatsapp: `I just donated to my own fundraising page on JustGiving. Please MATCHmyMILES by donating and help me hit my target. ${whatsAppUrl}`,
        },

        matchMyMilesConfig,
      }),
    };

    return dispatch({
      [CALL_API]: {
        requestName,
        returnHeaders: ['location'],
        requestOptions: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/hal+json; profile=jg.donationcollection; version=1.0',
            'cache-control': 'no-cache',
            Prefer: 'return=representation',
          },
          formData: postBody,
        },
        types: [types.CREATE_DONATION_PAGE_REQUEST, types.CREATE_DONATION_PAGE_SUCCESS, types.CREATE_DONATION_PAGE_FAILURE],
        endpoint: `${config.DONATE_API.BASE_URL}/api/donations`,
      },
    });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./actions/apiActions/apiActions.js